import { useEffect } from 'react'

/**
 * Enables compact listing-page layout: internal table scroll, unified filter params,
 * reduced global page scroll. Matches Expense Users (UAT) behavior.
 */
export function useListingPageLayout(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined
    document.body.classList.add('ss-listing-route')
    return () => {
      document.body.classList.remove('ss-listing-route')
    }
  }, [enabled])
}
